import { DeviceCommand } from "lib/deviceDrivers/sessionFramework/device/types";
import { ScpFrame } from "./types";
import {
  CommandQueueState,
  createCommandQueueState,
} from "lib/deviceDrivers/sessionFramework/protocol/commandQueue";
import { isRetryableDeviceErrorCode, matchesResponseMode } from "./frames";

/**
 * SCP wire payloads shared across all TruTest devices that implement this protocol.
 * These strings are the canonical commands defined by the Serial Command Protocol spec.
 */
export enum ScpCommandPayload {
  ENABLE_ACKS = "{ZA1}",
  ENABLE_ERRORS = "{ZE1}",
  GET_DATE = "{SD}",
  GET_SESSION_COUNT = "{FLN}",
  GET_NEXT_FIELD_CODE = "{FH}",
  GET_NEXT_SESSION_ID = "{FL}",
  GET_NEXT_RECORD = "{FN}",
  GET_TIME = "{ST}",
  QUERY_EID_OUTPUT_FORMAT = "{FS}",
  QUERY_LINE_ENDINGS = "{ZC}",
  RESET_SESSION_RECORD_CURSOR = "{FD}",
  SELECT_SESSION_DATA_MODE = "{FGDD}",
}

/**
 * Constructs one typed DeviceCommand from its protocol-level fields.
 * Timing and retry policy are always required — each driver supplies its own defaults.
 */
export function createCommand(
  name: string,
  payload: string,
  responseMode: DeviceCommand["responseMode"],
  {
    timeoutMs,
    maxRetries,
    retryOnBusy = true,
  }: Pick<DeviceCommand, "timeoutMs" | "maxRetries"> &
    Partial<Pick<DeviceCommand, "retryOnBusy">>,
): DeviceCommand {
  return { name, payload, responseMode, timeoutMs, maxRetries, retryOnBusy };
}

export function createScpCommandQueue(): CommandQueueState<ScpFrame> {
  return createCommandQueueState<ScpFrame>(
    matchesResponseMode,
    isRetryableDeviceErrorCode,
  );
}
